export function nodelistToArray (nodeList) {
  return [].slice.call(nodeList)
}



// WEBPACK FOOTER //
// ./src/lib/nodelistToArray.js